import { render, staticRenderFns } from "./TermsOfServicePopup.vue?vue&type=template&id=d1708578"
import script from "./TermsOfServicePopup.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports